import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@usucampeao/utils-frontend';
import { NgxMaskModule } from 'ngx-mask';
import { ContratoCdhuComponent } from './contrato-cdhu/contrato-cdhu.component';
import { ContratosV3Component } from './contratos-v3.component';
import { ProcuracaoReurbAverbacaoV3Component } from './procuracao-reurb-averbacao/procuracao-reurb-averbacao-v3.component';
import { ReurbAverbacaoV3Component } from './reurb-averbacao-v3/reurb-averbacao-v3.component';
import { SomenteAverbacaoV3Component } from './somente-averbacao-v3/somente-averbacao-v3.component';
import { TabelaValoresComponent } from './tabela-valores/tabela-valores.component';

@NgModule({
  imports: [
    CommonModule,
    NgxMaskModule.forRoot(),
    PipesModule,
  ],
  declarations: [
    ContratoCdhuComponent,
    ContratosV3Component,
    ProcuracaoReurbAverbacaoV3Component,
    ReurbAverbacaoV3Component,
    SomenteAverbacaoV3Component,
    TabelaValoresComponent,
  ],
  exports: [
    ContratosV3Component,
  ],
})
export class ContratosV3Module { }
